angular.module('tgaAdmin').controller('ReportModalController', [
  '$scope',
  '$timeout',
  '$uibModalInstance',
  '$uibModalStack',
  'reportService',
  'notificationService',
  'gameService',
  'extras',
  '$log',
  'settingsService',
  '$translate',
  function (
    $scope,
    $timeout,
    $uibModalInstance,
    $uibModalStack,
    reportService,
    notificationService,
    gameService,
    extras,
    $log,
    settingsService,
    $translate,
  ) {
    $scope.data = {
      alerts: [],
      closeButton: true,
      report: extras.report,
      datePickerOptions: settingsService.getDatePickerOptions(
        {
          opens: 'right',
          autoApply: false,
        },
        {
          'apply.daterangepicker': function (ev, picker) {
            $scope.viewmodel.range = picker.chosenLabel;

            if (
              !$scope.viewmodel.dateRange.startDate.isSame($scope.viewmodel.oldRange.startDate, 'day')
              || !$scope.viewmodel.dateRange.endDate.isSame($scope.viewmodel.oldRange.endDate, 'day')
            ) {
              $scope.viewmodel.dateRange = $scope.viewmodel.oldRange = {
                startDate: picker.startDate,
                endDate: picker.endDate,
              };
            }
          },
          'outsideClick.daterangepicker': function () {
            $scope.viewmodel.dateRange = {
              startDate: $scope.viewmodel.oldRange.startDate,
              endDate: $scope.viewmodel.oldRange.endDate,
            };
          },
        },
      ),
    };

    $scope.viewmodel = {
      modal_title: 'Generate Report',
      report_id: null,
      name: null,
      filetype: 'csv',
      range:
        Object.keys($scope.data.datePickerOptions.ranges).find(
          (key) => $scope.data.datePickerOptions.ranges[key][0].isSame(
            extras.report.start_date
              ? moment(extras.report.start_date)
              : moment()
                .subtract(29, 'days')
                .startOf('day'),
            'day',
          )
            && $scope.data.datePickerOptions.ranges[key][1].isSame(
              extras.report.end_date ? moment(extras.report.end_date) : moment().endOf('day'),
              'day',
            ),
        ) || 'Custom',
      oldRange: {
        startDate: extras.report.start_date
          ? moment(extras.report.start_date)
          : moment()
            .subtract(29, 'days')
            .startOf('day'),
        endDate: extras.report.end_date ? moment(extras.report.end_date) : moment().endOf('day'),
      },
      dateRange: {
        startDate: extras.report.start_date
          ? moment(extras.report.start_date)
          : moment()
            .subtract(29, 'days')
            .startOf('day'),
        endDate: extras.report.end_date ? moment(extras.report.end_date) : moment().endOf('day'),
      },
      progress: 0,
      total: 0,
      download: null,
      exclude_empty: true,
      selectAllCurrent: false,
      selectEverythingModel: false,
      filteringCriteriaGameName: '',
      filteringCriteriaCreatedBy: '',
      filteringCriteriaArchived: '',
      games: [],
      currentGames: [],
      selected: {},
      gamesDict: {},
      overall_games: false,
      players: false,
      selectedArchived: 'trivia',
      selectedGamesType: 'active',
      displayMetrics: false,
      metricsRequestTimeout: false,
      reportMetrics: [],
      reportFailed: false,
      reportCanceled: false,
      displayCancelConfirm: false,
      cancelReportProcessing: false,
    };

    $scope.initialize = function () {
      $scope.loading = true;
      $scope.loadingMetrics = false;
      $scope.viewmodel.loadedViaSearch = new Set();

      settingsService.getSettings().then((settings) => {
        $scope.data.datePickerOptions.ranges['All Time'] = [moment(settings.date_created).startOf('month'), moment()];
      });

      reportService
        .getReports({
          report_type: extras.report.report_type,
          complete: 0,
          start: 0,
          canceled: 0,
          limit: 1,
        })
        .then((reports) => {
          $log.log('reports', reports);
          if (reports.length) {
            $scope.viewmodel.report_id = reports[0].report_id;
            $scope.actions.watchReport();
          } else {
            $scope.loading = false;
            $scope.actions.resizeModal('large');
          }
        });
    };

    $scope.guards = {
      disableGenerationButton() {
        const selectedTrue = Object.values($scope.viewmodel.selected).filter(s => s === true);
        if (selectedTrue.length || $scope.viewmodel.players || $scope.viewmodel.overall_games) return false;
        return true;
      }
    };

    $scope.actions = {
      filterChange(reset) {
        if (reset) {
          $scope.viewmodel.filteringCriteriaGameName = '';
          $scope.viewmodel.filteringCriteriaCreatedBy = '';
          $scope.viewmodel.filteringCriteriaArchived = '';
        }
      },
      loadGames(tableState, stTableController) {
        $scope.tableLoading = true;
        $scope.viewmodel.stTableController = stTableController;
        if (!tableState) {
          tableState = $scope.viewmodel.oldTableState;
        }

        const params = tableState
          ? {
            paginate: true,
            page: Math.floor(tableState.pagination.start / tableState.pagination.number) + 1,
            limit: tableState.pagination.number,
            sort: tableState.sort.predicate,
            order: tableState.sort.reverse ? 'desc' : 'asc',
          }
          : {};
        tableState.start = params.page;
        if (tableState?.search?.predicateObject) {
          $log.log(tableState?.search?.predicateObject);
          Object.keys(tableState.search.predicateObject).forEach((key) => {
            params[key] = tableState.search.predicateObject[key];
          });
        }

        gameService.getGames(params).then((response) => {
          $log.log('games', response);
          $scope.viewmodel.total = response.total;
          $scope.loading = false;
          if (!(params.page in $scope.viewmodel.gamesDict)) {
            // Check for paginated response coming from `items` before falling back to the response
            $scope.viewmodel.gamesDict[params.page] = response.items || response;
          } else if ($scope.actions.isCurrentlyFiltering()) {
            // keeping a record of items loaded via search
            response.items.forEach((g) => {
              $scope.viewmodel.loadedViaSearch.add(g);
            });
          }

          // Builds a record of games from all loaded pages, then adds to that the games loaded via search
          const { gamesDict } = $scope.viewmodel;
          const loadedPages = Object.keys(gamesDict);
          $scope.viewmodel.games = new Set(loadedPages.reduce((x, y) => x.concat(gamesDict[y]), []));
          $scope.viewmodel.loadedViaSearch.forEach((g) => $scope.viewmodel.games.add(g));
          $scope.viewmodel.currentGames = $scope.actions.isCurrentlyFiltering()
            ? response.items
            : gamesDict[params.page];

          if (tableState) {
            tableState.pagination.numberOfPages = Math.ceil(response.total / tableState.pagination.number);
            tableState.pagination.totalItemCount = response.total;
            $scope.viewmodel.numberOfPages = tableState.pagination.numberOfPages;
            $timeout(() => { });
          }
          $scope.tableLoading = false;
        });
      },
      isCurrentlyFiltering() {
        const vm = $scope.viewmodel;
        return vm.filteringCriteriaGameName || vm.filteringCriteriaCreatedBy;
      },
      resizeModal(size) {
        if (size === 'small') {
          $('.modal-dialog')
            .css({ transition: 'width 0.3s' })
            .removeClass('modal-lg');
        } else {
          $('.modal-dialog')
            .css({ transition: 'width 0.3s' })
            .addClass('modal-lg');
        }
      },
      watchReport() {
        if ($scope.viewmodel.reportCanceled) return;
        $scope.actions.resizeModal('small');
        $scope.viewmodel.modal_title = 'Processing report...';
        reportService
          .getProgress($scope.viewmodel.report_id)
          .then((response) => {
            $scope.viewmodel.progress = response.progress;
            if ($scope.viewmodel.progress > 0) {
              $scope.loading = false;
            }

            if (response.url) {
              $scope.viewmodel.download = response.url;
              $scope.viewmodel.modal_title = 'Your report is ready!';
              notificationService.getUnread();
            } else {
              $scope.timer = $timeout(() => {
                $scope.actions.watchReport();
              }, 2000);
            }
          })
          .catch(() => {
            $scope.timer = $timeout(() => {
              $scope.actions.failedReport();
            }, 3000);
          });
      },
      failedReport() {
        if ($scope.viewmodel.reportCanceled) return;
        $scope.viewmodel.reportFailed = true;
        $scope.loading = false;
        $scope.viewmodel.modal_title = 'Your report failed to generate.';
      },
      showReportMetrics(metricsResponse, timeout) {
        $scope.viewmodel.displayMetrics = true;
        $scope.actions.resizeModal('small');
        $scope.viewmodel.modal_title = 'Are you sure...';
        if (!timeout) {
          $scope.viewmodel.reportMetrics = metricsResponse;
        } else {
          $scope.viewmodel.metricsRequestTimeout = true;
        }

      },
      selectAllData() {
        $scope.viewmodel.games.forEach((g) => {
          $scope.viewmodel.selected[g.game_id] = true;
        });
      },
      unselectAllData() {
        $scope.viewmodel.games.forEach((g) => {
          $scope.viewmodel.selected[g.game_id] = false;
        });
      },
      onGamesTypeSelected() {
        if ($scope.viewmodel.selectedGamesType === 'archived') {
          $scope.actions.selectArchived(true);
        } else if ($scope.viewmodel.selectedGamesType === 'active') {
          $scope.actions.selectArchived(false);
        } else {
          $scope.actions.selectArchived(null);
        }
      },
      selectArchived(isArchived) {
        const tState = $scope.viewmodel.stTableController.tableState();
        tState.search = { predicateObject: { is_archived: isArchived } };
        tState.pagination.start = 1;
        $scope.viewmodel.filteringCriteriaArchived = isArchived;
        $scope.viewmodel.gamesDict = {};
        $scope.viewmodel.games = [];
        $scope.viewmodel.selected = {};
        $scope.viewmodel.currentGames = [];
        $scope.viewmodel.selectEverythingModel = false;
        $scope.actions.updateAllSelection();

        $scope.actions.loadGames(tState, $scope.viewmodel.stTableController);
      },
      selectAllCurrent(forceSelectValue) {
        $scope.viewmodel.currentGames.forEach((g) => {
          if (angular.isDefined(forceSelectValue)) {
            $scope.viewmodel.selected[g.game_id] = forceSelectValue;
          } else {
            $scope.viewmodel.selected[g.game_id] = $scope.viewmodel.selectAllCurrent;
          }
        });
      },
      updateAllSelection() {
        if ($scope.viewmodel.selectEverythingModel) {
          $scope.actions.selectAllData();
        } else {
          $scope.actions.unselectAllData();
        }
      },
      totalSelected() {
        // total selected in filtered list
        if ($scope.viewmodel.selectEverythingModel) {
          return String($scope.viewmodel.total);
        }

        // total selected in main list
        let totalAllSelected = 0;
        Object.keys($scope.viewmodel.selected).forEach((x) => {
          totalAllSelected += $scope.viewmodel.selected[x] === true ? 1 : 0;
        });
        return totalAllSelected;
      },
      getMetrics() {
        const report = (ids) => {
          $scope.viewmodel.modal_title = 'Calculating Report Size';
          $scope.loading = true;
          $scope.loadingMetrics = true;
          reportService
            .getReportMetrics({
              'games[]': ids,
              select_all: $scope.viewmodel.selectedGamesType === 'active' ? $scope.viewmodel.selectEverythingModel : false,
              overall_games: $scope.viewmodel.overall_games,
              players: $scope.viewmodel.players,
              archived_filter: $scope.viewmodel.filteringCriteriaArchived,
              name: $scope.viewmodel.name,
              game_name: $scope.viewmodel.filteringCriteriaGameName,
              created_by_name: $scope.viewmodel.filteringCriteriaCreatedBy,
              report_type: extras.report.report_type,
              start_date: $scope.viewmodel.dateRange.startDate.toISOString(true),
              end_date: $scope.viewmodel.dateRange.endDate.toISOString(true),
              filetype: $scope.viewmodel.filetype,
              exclude_empty: $scope.viewmodel.exclude_empty,
            }, 30000)
            .then((response) => {
              $scope.actions.showReportMetrics(response);
              $scope.loading = false;
              $scope.loadingMetrics = false;
            })
            .catch((error) => {
              $log.error('Unable to get metrics.', error);
              $scope.actions.showReportMetrics({}, true);
              $scope.loading = false;
              $scope.loadingMetrics = false;
              $scope.viewmodel.filetype = 'csv';
            });
        };

        if ($scope.viewmodel.selectedGamesType === 'active' && $scope.viewmodel.selectEverythingModel) {
          report([]);
        } else { // game type == archived or active
          const isArchived = $scope.viewmodel.selectedGamesType === 'archived';
          let gameIds = [];
          gameService.getGames({ exclude_extra_data: true, is_archived: isArchived }).then((games) => {
            gameIds = games.map((g) => g.game_id);
            if (!$scope.viewmodel.selectEverythingModel) {
              gameIds = gameIds.filter(
                (game_id) => (game_id in $scope.viewmodel.selected && $scope.viewmodel.selected[game_id] === true),
              );
            }

            report(gameIds);
          });
        }
      },
      toggleCancelRequest(toggle) {
        $scope.viewmodel.displayCancelConfirm = toggle;
      },
      submit() {
        $scope.loading = true;
        $scope.viewmodel.displayMetrics = false;
        const report = (ids) => {
          reportService
            .addReportToQueue({
              games: ids,
              select_all: $scope.viewmodel.selectedGamesType === 'active' ? $scope.viewmodel.selectEverythingModel : false,
              overall_games: $scope.viewmodel.overall_games,
              players: $scope.viewmodel.players,
              archived_filter: $scope.viewmodel.filteringCriteriaArchived,
              name: $scope.viewmodel.name,
              game_name: $scope.viewmodel.filteringCriteriaGameName,
              created_by_name: $scope.viewmodel.filteringCriteriaCreatedBy,
              report_type: extras.report.report_type,
              start_date: $scope.viewmodel.dateRange.startDate.toISOString(true),
              end_date: $scope.viewmodel.dateRange.endDate.toISOString(true),
              filetype: $scope.viewmodel.filetype,
              exclude_empty: $scope.viewmodel.exclude_empty
            })
            .then((response) => {
              $scope.viewmodel.report_id = response.report_id;
              $scope.actions.watchReport();
            })
            .catch((error) => {
              $log.error('Unable to add report.', error);
              $scope.loading = false;
              $scope.actions.resizeModal('large');
            });
        };

        if ($scope.viewmodel.selectedGamesType === 'active' && $scope.viewmodel.selectEverythingModel) {
          report([]);
        } else { // game type == archived or active
          const isArchived = $scope.viewmodel.selectedGamesType === 'archived';
          let gameIds = [];
          gameService.getGames({ exclude_extra_data: true, is_archived: isArchived }).then((games) => {
            gameIds = games.map((g) => g.game_id);
            if (!$scope.viewmodel.selectEverythingModel) {
              gameIds = gameIds.filter(
                (game_id) => (game_id in $scope.viewmodel.selected && $scope.viewmodel.selected[game_id] === true),
              );
            }

            report(gameIds);
          });
        }
      },
      cancel() {
        if (!$scope.viewmodel.report_id && $scope.viewmodel.report_id !== 0) {
          $log.error('ReportModal - cancel(): No report_id provided to cancel');
          $scope.actions.createAlert(
            `<span class="fa fa-exclamation-triangle"></span> ${$translate
              .instant('modal.report_canceled_error')
              .toString()}`,
            'danger',
          );
          return;
        }
        $scope.viewmodel.cancelReportProcessing = true;
        reportService.cancelReport({
          report_id: $scope.viewmodel.report_id,
        }).then(() => {
          $scope.viewmodel.reportCanceled = true;
          $scope.viewmodel.modal_title = $translate
            .instant('modal.report_canceled_title')
            .toString()
        }).catch(() => {
          $scope.actions.createAlert(
            `<span class="fa fa-exclamation-triangle"></span> ${$translate
              .instant('modal.report_canceled_error')
              .toString()}`,
            'danger',
          );
        }).finally(() => {
          $scope.viewmodel.displayCancelConfirm = false;
          $scope.viewmodel.cancelReportProcessing = false;
        })
      },
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });
      },
      close() {
        $uibModalInstance.dismiss();
      },
    };

    $scope.$on('$destroy', () => {
      // Cancel timer when modal closes
      $timeout.cancel($scope.timer);
    });

    $scope.initialize();
  },
]);
